import { Navigation } from '@app/navigation/enums/navigation.enum';

export const baseRoute = ['/', Navigation.OTS, Navigation.Tots];

export enum TelecomStep {
    Interest = 'telecom-interest',
    Qualification = 'telecom-qualification',
    Success = 'telecom-success',
}

export enum TelecomInterest {
    Interested = 'interested',
    Unknown = 'unknown',
    NotInterested = 'notInterested',
}

//Step order
export const steps: TelecomStep[] = [TelecomStep.Interest, TelecomStep.Qualification, TelecomStep.Success];

export enum FormControlGroups {
    StepInterest = 'stepInterest',
    StepQualification = 'stepQualification',
}

export enum FormControlNames {
    Interest = 'interest',
    Bundle = 'bundle',
    Provider = 'provider',
}
